export enum HideModalReason {
  CANCELLED = 'cancel',
  COMPLETED = 'complete',
}
